import React from "react";
import { Typography } from "@ann/web-components";
import { 
  MessageContainerWrapper, 
  UserMessage, 
  SystemMessage 
} from "./MessageContainer.styled";

const MessageContainer = ({ messages = [] }) => {
  return (
    <MessageContainerWrapper>
      {messages.map((message, index) => {
        if (message.type === "user") {
          return (
            <UserMessage key={index}>
              <Typography
                category="body"
                size="medium"
                weight="regular"
              >
                {message.content}
              </Typography>
            </UserMessage>
          );
        } else {
          return (
            <SystemMessage key={index}>
              <Typography
                category="body"
                size="medium"
                weight="regular"
              >
                {message.content}
              </Typography>
            </SystemMessage>
          );
        }
      })}
    </MessageContainerWrapper>
  );
};

export default MessageContainer;

